/**
 * Centralized TanStack Query key factory.
 *
 * Every query in the app should reference keys from here so that:
 *  - Invalidation is consistent (no typo-based cache misses)
 *  - Related queries can be bulk-invalidated via prefix (e.g. orders.all())
 *  - Adding new queries is discoverable
 *
 * Pattern: each domain exposes:
 *   .all()        → matches every query in the domain  (useful for broad invalidation)
 *   .lists()      → matches list queries only
 *   .list(filters)→ a specific filtered list
 *   .details()    → matches all detail queries
 *   .detail(id)   → a single-entity query
 */

export const queryKeys = {
  orders: {
    all: () => ["orders"] as const,
    detail: (id: string) => ["orders", id] as const,
  },

  designs: {
    all: () => ["designs"] as const,
  },

  products: {
    all: () => ["products"] as const,
    detail: (id: string) => ["product", id] as const,
  },

  addresses: {
    all: () => ["addresses"] as const,
  },

  assets: {
    all: () => ["assets"] as const,
    lists: () => ["assets", "list"] as const,
    list: (filters: { source?: string; category?: string; search?: string }) =>
      ["assets", "list", filters] as const,
  },

  assetCategories: {
    all: () => ["asset-categories"] as const,
  },

  catalog: {
    all: () => ["catalog"] as const,
    detail: (slug: string) => ["catalog", slug] as const,
  },

  cart: {
    all: () => ["cart"] as const,
    validation: () => ["cart", "validation"] as const,
  },
} as const;
